module.exports = __webpack_public_path__ + "img/sceneBack3.d01138c8.png";